import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { Link, useLocation} from "react-router-dom";
import { useNavigate, useParams } from "react-router";
import { TopBar } from "../../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../../config/routeConfig";
import { GeneralEdit } from "./GeneralEdit";
import { GeneralInvestmentContactEdit } from "./GeneralInvestmentContactEdit";
import { AddressesEdit } from "./AddressesEdit";
import { OthersEdit } from "./OthersEdit";
import "../../../investor/investor.css";

export const ContactsEdit = (props) => {
  const locationData = useLocation();

  const dispatch = useDispatch();
  const params = useParams();

  const [loading, setLoading] = useState(true);
  const [selectedContactInfoButton, setContactInfoButton] = useState(locationData.state === null ? "" : locationData.state.SelectedContactInfoButton);
  const [contactDetails, setContactDetails] = useState(locationData.state === null ? "" : locationData.state.ContactDetails);
  const [contactTypeId,setcontactTypeId]=useState(locationData.state === null ? "" : locationData.state.ContactTypeId);
  const ContactFullName = locationData?.state?.ContactFullName;


  const queryParams = new URLSearchParams(locationData.search);
  const paramValue = queryParams.get('ContactTypeId'); 

  useEffect(() => {
    document.title = `Investor Details`;
  }, []);

  useEffect(() => {
    setLoading(false);
  }, []);



  const contactName = contactDetails !== undefined ? contactDetails?.preferredName : ContactFullName;
  const edit = params.ContactId !== "0" ? `${contactName} > Edit` : "";
  const addNew = params.ContactId === "0" ?  "New Contact" : "";

  let Level = [{ BreadCrumb: contactTypeId===1? "Investors > ":"CRM >", Routes: `${UrlPath.InvestorDetailsEdit}` }];
  Level = loading
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `${
            params.ContactId !== "0"
              ? edit
              : addNew
          } `,
          Routes: `${
            params.ContactId !== "0"
              ? UrlPath.InvestorDetails
              : UrlPath.Investor
          }${params.ContactId !== "0" ? params.ContactId : ""}`,
        },
      ];
  
  let editComponentToRender;
  let newEditTitleName;

    switch (selectedContactInfoButton) {
      case 1:
        newEditTitleName = params.ContactId !== "0" ? "General Edit" : "General Details";
        editComponentToRender =  paramValue==="1"?<GeneralEdit contactDetails={contactDetails}/>:<GeneralInvestmentContactEdit contactDetails={contactDetails}></GeneralInvestmentContactEdit>;
        break;
      case 2:
        newEditTitleName = "Addresses Edit";
        editComponentToRender = <AddressesEdit contactDetails={contactDetails}/>;
        break;
      case 3:
        newEditTitleName = "Other Details Edit";
        editComponentToRender = <OthersEdit contactDetails={contactDetails}/>;
        break;
      default:
        newEditTitleName = params.ContactId !== "0" ? "General Edit" : "General Details";
        editComponentToRender = paramValue==="1"?<GeneralEdit contactDetails={contactDetails}/>:<GeneralInvestmentContactEdit contactDetails={contactDetails}></GeneralInvestmentContactEdit>;
        break;
    }

    return (
      <>
        {loading ? (
          <>
            <LoadingScreen />
          </>
        ) : (
          <>
            <TopBar label={paramValue==1 ? "Investor" : "Investment"} />
            <div id="content" className="asset-detail-screen">
              <BreadCrumbs Levels={Level} />
              <div className="container-fluid">
                <div className="header-container m-3">
                  <b>{newEditTitleName}</b>
                </div>
                {editComponentToRender}
              </div>
            </div>
          </>
        )}
      </>
    );
};
